import React from 'react';

/** An on/off flag the FTUX holds while it shows something, and the page that reads it. */
export type HeldFlag = {
  set: (next: boolean) => void;
  /** React hook: re-renders its component when the flag flips. */
  useHeld: () => boolean;
};

/**
 * A flag the FTUX can hold while it shows something on a page: the phone's More drawer kept open while the map tells
 * its parts, Game Lists' micro drag kept playing. The FTUX sets it and the page reads it; whoever sets it releases it
 * (false) in its cleanup. Never held outside the FTUX, so the page then behaves as before.
 */
export const createHeldFlag = (): HeldFlag => {
  let held = false;
  const listeners = new Set<() => void>();
  const subscribe = (listener: () => void): (() => void) => {
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  };
  const read = (): boolean => held;
  const set = (next: boolean): void => {
    if (held === next) return;
    held = next;
    listeners.forEach((listener) => listener());
  };
  return {
    set,
    useHeld: () => React.useSyncExternalStore(subscribe, read, read),
  };
};
